import React from 'react';

const FloatingWhatsApp = () => {
  return (
    <a
      href="whatsapp://send?phone=5492236661214&text=Hola%2C%20necesito%20asesoramiento%20sobre%20mi%20caso%20que%20se%20trata%20de..."
      data-testid="floating-whatsapp-btn"
      className="fixed bottom-24 right-6 z-[10000] flex items-center justify-center w-16 h-16 bg-[#25D366] hover:bg-[#128C7E] rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 group"
      aria-label="Contactar por WhatsApp"
    >
      <svg viewBox="0 0 32 32" className="w-9 h-9" fill="white">
        <path d="M16 0C7.163 0 0 7.163 0 16c0 2.822.732 5.47 2.016 7.773L0 32l8.489-2.004A15.917 15.917 0 0016 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm8.165 22.635c-.341.957-1.679 1.751-2.765 1.983-.746.159-1.72.285-4.998-1.074-4.196-1.737-6.893-5.997-7.102-6.274-.201-.269-1.69-2.249-1.69-4.29 0-2.042 1.07-3.047 1.449-3.463.341-.374.907-.54 1.449-.54.175 0 .332.009.474.017.379.016.569.038.819.634.312.746 1.07 2.609 1.163 2.801.094.193.16.42.032.672-.12.252-.181.41-.354.632-.175.222-.369.496-.527.666-.175.185-.357.387-.153.758.201.371.897 1.48 1.927 2.397 1.323 1.178 2.438 1.544 2.783 1.716.345.172.548.145.75-.087.208-.24.878-1.025 1.113-1.38.227-.354.462-.294.784-.177.322.12 2.041.963 2.391 1.138.35.172.581.261.666.404.087.143.087.831-.253 1.637z"/>
      </svg>
      
      <span className="absolute right-20 bg-slate-800 text-white text-sm px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap shadow-lg">
        Chateá con nosotros
      </span>
      
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25"></span>
    </a>
  );
};

export default FloatingWhatsApp;
